<template>
	<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
		<path class="path"
					d="M8.83436 17.2699L10.2825 11.1989L12.5642 12.749L11.1261 10.3213L17.2701 8.95383L11.1261 7.86069L12.5642 5.25106L10.2825 6.92052L8.83436 0.637756L7.74796 7.03618L5.16951 5.25106L6.62958 7.86069L0.572998 8.95383L6.62958 10.3213L5.16951 12.749L7.74796 11.1989L8.83436 17.2699Z"/>
	</svg>

</template>

<script>
export default {
	data () {
		return {}
	},

	methods: {
		onClick (id) {
			this.$parent.$emit('clicked', id)
		}
	}
}
</script>
